export default "__VITE_ASSET__BfBDEYfz__"